import {AxiosInstance} from 'axios';
import {Test} from '../../models/test';
import {responseHandler} from './response';
import {Exam} from '../../models/exam';
import {Subscription} from '../../models/subscription';
import {Session} from "../../models/session";
import {Question, QuestionAttempt, QuestionGroup} from "../../models/question";
import {SectionName} from "../../models/section";

export const createSession = async (client: AxiosInstance, section: SectionName, testId?: string) =>
    responseHandler<{
        sessionId: string,
        test: Test,
        questions: (Question | QuestionGroup)[],
        subsectionInstructions: { [k: number]: string },
        audioContent: {
            [v in "questions" | "instructions"]: { [k: number]: string[] }
        }
    }>(client.post(`/sessions?section=${section}`, testId ? {
        testId
    } : {}))

export const submitSession = async (client: AxiosInstance, data: {
    sessionId: string,
    questionAttempts: QuestionAttempt[]
}) =>
    responseHandler<string>(client.post('/sessions/submit', data))

export const getTestResults = async (client: AxiosInstance, page?: number, limit?: number) =>
    responseHandler<{
        data: Session[],
        count: number
    }>(client.get(`/sessions?status=reviewed&page=${page || 1}&limit=${limit}`), true)

export const getSession = async (client: AxiosInstance, sessionId: string) =>
    responseHandler<Session>(client.get(`/sessions/${sessionId}`))